import { render, staticRenderFns } from "./BarMenu.vue?vue&type=template&id=67554c74"
import script from "./BarMenu.vue?vue&type=script&lang=js"
export * from "./BarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports